import React from 'react';
import { ErrorBox, Loading, Link } from '~/utils';
import { useQuery } from '~/hooks';

export function InfoIndex( props ) {
  const { data : files, error } = useQuery( 'info' );
  if ( error ) return <ErrorBox error={error} />;
  if ( ! files ) return <Loading />;
  return (
    <ul>
      {files.map( file => {
        if ( file.hide ) return null;
        const key = file.id;
        const link = `/info/${file.id}`;
        const title = file.title || file.id;
        return <li key={key}><Link to={link}>{title}</Link></li>;
      } )}
    </ul>
  );
}
// <li><Link to="/info/system">System Information</Link></li>
